// Design-System Token-Dateien (verbatim portiert)
import './styles/ds/styles.css';
// App-Level CSS (Klassen-Namen identisch zum Design-Ref)
import './styles/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from './ui/index';
import App from './App';

const root = document.getElementById('root');
if (!root) throw new Error('Kein #root-Element gefunden');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);
